angular.module('sharecrf.internal-value', ['sharecrf.unknown-value'])
    .run(['$rootScope', 'MISSING_VALUE', function($rootScope, MISSING_VALUE) {
        // eslint-disable-next-line angular/no-run-logic
        $rootScope.MISSING_VALUE = MISSING_VALUE;
    }]);
